import { handleSessionLessApi } from './common';

export const get_option_chain_expiry_dates = async (Api, token, segment_id) => {
	try {
		const res = await Api.get(API_ENDPOINTS.optionExpiryDates(token, segment_id));
		return handleSessionLessApi(res);
	} catch (e) {
		throw new Error('error in get_option_expiry_dates');
	}
};

export const get_option_chain_data = async (Api, params) => {
	try {
      const res = await Api.get(API_ENDPOINTS.optionChain, params);
	  return handleSessionLessApi(res);
	} catch(e) {
      throw new Error('error in optionChainv2 api');
	}
}

export const get_option_chain_next_page = async (Api, url) => {
	try {
      const res = await Api.get(url);
	  return handleSessionLessApi(res);
	} catch(e) {
      throw new Error('error in optionChainv2 api');
	}
}	

const API_ENDPOINTS = {
	optionExpiryDates: (token, segment_id) =>  `expirydates?token=${token}&instrument=option&segment_id=${segment_id}`,
	optionChain: `scripdetailsfromstrike`,
};